import { KpiType } from 'fabscale-app/models/enums/kpi-types';
import { BaseEnumHelper } from './-base';

export default class EnumKpiTypeDescriptionHelper extends BaseEnumHelper<KpiType> {
  getLabel(enumValue: KpiType) {
    return this.enumLabels.kpiTypeDescription(enumValue);
  }
}
